import { type FC } from "react";

import { Badge } from "@mantine/core";

import { LensPayoutState, LensScoreEligibility, LensScoreFinalizationStatus } from "../../../gql-generated/types";
import { formatMilliUsd } from "../../../lens-creator-payout/utils/formatMilliUsd";
import { type LensScoreWindowFieldsFragment } from "../../api/queries";
import { chip } from "../top-performer/TopPerformerStatusChip.module.css";

import { StatusLabel } from "./messages.generated";

export const LensPlusPayoutChip: FC<{ window: LensScoreWindowFieldsFragment; minimum: number }> = ({
    window,
    minimum,
}) => {
    if (window.payout.state === LensPayoutState.Paid)
        return (
            <Badge radius="xl" className={chip} color="green" variant="light" tt="none">
                {formatMilliUsd(window.payout.amountMilliUsd)}
            </Badge>
        );
    let status = "noPayout";
    if (
        window.payout.state === LensPayoutState.Pending &&
        window.finalizationStatus === LensScoreFinalizationStatus.Finalized
    )
        status = "pending";
    else if (window.eligibility === LensScoreEligibility.NotEligible) status = "notEligible";
    else if (!window.totals) {
        if (window.windowStart.slice(0, 7) !== new Date().toISOString().slice(0, 7)) return <>-</>;
        status = "awaiting";
    } else if (window.totals.lensScore === 0) status = "noActivity";
    else if (window.eligibility === LensScoreEligibility.BelowMinimum || window.totals.lensScore < minimum)
        status = "belowMinimum";
    else if (window.finalizationStatus === LensScoreFinalizationStatus.Estimated) status = "onTrack";
    const colors: Record<string, string> = { onTrack: "green", pending: "orange", belowMinimum: "orange" };
    return (
        <Badge radius="xl" className={chip} color={colors[status] ?? "gray"} variant="light" tt="none">
            <StatusLabel status={status} />
        </Badge>
    );
};
